import React from "react";
import type { BaseProps } from "@purpur/common-types";
import { Spinner } from "@purpur/spinner";
import c from "classnames/bind";

import styles from "./card-cta.module.scss";

const cx = c.bind(styles);

export type CardCtaProps = BaseProps & {
  disabled?: boolean;
  /**
   * The position of the icon.
   * `"left" | "right"`
   */
  iconPosition?: "left" | "right";
  loading?: boolean;
  /**
   * Use this to style the cta as a link (no border)
   */
  linkStyling?: boolean;
  text?: string;
};

const rootClassName = "purpur-card-cta";

export const CardCta = ({
  ["data-testid"]: dataTestId = "purpur-card-cta",
  className,
  children,
  disabled = false,
  iconPosition = "right",
  loading = false,
  text,
  linkStyling = false,
  ...props
}: CardCtaProps) => {
  return (
    <div
      className={`${cx([
        rootClassName,
        className,

        {
          [`${rootClassName}--disabled`]: disabled,
          [`${rootClassName}--text`]: !!text,
          [`${rootClassName}--cta-styling`]: linkStyling,
          [`${rootClassName}--button-styling`]: !linkStyling,
          [`${rootClassName}--button-styling--md`]: !linkStyling,
          [`${rootClassName}--button-styling--secondary`]: !linkStyling,
          [`${rootClassName}--button-styling--icon-only`]: !linkStyling && !text,
        },
      ])} ${rootClassName}`}
      data-testid={dataTestId}
      {...props}
    >
      {!loading ? (
        <>
          {iconPosition === "left" && children}
          {text}
          {iconPosition === "right" && children}
        </>
      ) : (
        <Spinner data-testid={`${dataTestId}-spinner`} size="xs" disabled={disabled} />
      )}
    </div>
  );
};
